import { shouldTrackUpdate, stampLocalUpdatedAt } from './timestamps';

/**
 * Plain document data passed to RxDB hooks. Hooks receive and mutate these
 * objects in place rather than RxDocument instances.
 *
 * @typedef {Object} CollectionDocumentData
 * @property {string} id
 * @property {number} [updatedAt] When the current document content last changed.
 * @property {number|null} [lastSyncedAt] Server updated_at last confirmed on device.
 */

export const writableCollectionHooks = {
  /**
   * @param {CollectionDocumentData} plainData
   */
  preInsert(plainData) {
    stampLocalUpdatedAt(plainData);
  },

  /**
   * RxDB types the second argument as RxDocument, but incrementalPatch (our
   * main write path) passes plain document data instead.
   *
   * @see https://github.com/pubkey/rxdb/issues/7355
   * @param {CollectionDocumentData} newData Document about to be written; mutated in place.
   * @param {CollectionDocumentData} previousData Document state before this write.
   */
  preSave(newData, previousData) {
    if (!shouldTrackUpdate(previousData, newData)) {
      return;
    }

    newData.updatedAt = Date.now();
  }
};

/**
 * @param {import('rxdb').RxDatabase} db
 */
export function registerWritableCollectionHooks(db) {
  for (const collection of Object.values(db.collections)) {
    collection.preInsert(writableCollectionHooks.preInsert, false);
    collection.preSave(writableCollectionHooks.preSave, false);
  }
}
